import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { ValidationError } from '../../../../domain/error.model';
import { ErrorAwareComponent, LsnErrorStateMatcher } from '../../../shared/middleware/error-state-matcher';
import { ErrorsState } from '../../store/errors.state';
import { UserAction } from '../../store/user.action';

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit, OnDestroy, ErrorAwareComponent {

    subscriptions: Subscription[] = [];
    errors: ValidationError[] = [];

    password = '';
    password2 = '';

    matchers = {
        password: new LsnErrorStateMatcher(this, 'password'),
        password2: new LsnErrorStateMatcher(this, 'password2'),
    };

    constructor(private store: Store, private route: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(ErrorsState.getMainErrors).subscribe(errors => this.errors = errors)
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    submit() {
        const token = this.route.snapshot.paramMap.get('token');
        this.store.dispatch(new UserAction.ResetPassword(token, this.password, this.password2));
    }

}
